import useEmitter, { EmitterEvents } from "@/hooks/useEmitter";
import useResourcesStore from "@/store/useResourcesStore";
import useUpgradesStore from "@/store/useUpgradesStore";
import { ResourceType } from "../entities/config/resources";
import type { UpgradeId } from "../entities/config/upgrades";
import { upgrades } from "../entities/config/upgrades";
import type { EventUpgradeIds } from "../entities/config/upgrades/";
import { eventUpgrades } from "../entities/config/upgrades/event";

export const getUpgradeCurrentReplaceValueById = (
	id: UpgradeId | EventUpgradeIds,
): number => {
	const upgrade = upgrades.get(id) || eventUpgrades.get(id);
	if (!upgrade) return 0;
	return (
		(upgrade.replaceValue || 0) * useUpgradesStore().getCurrentLevelById(id)
	);
};

export const increaseExplorationSpeed = (value: number): void => {
	useResourcesStore().increase(
		ResourceType.EXPLORATION_SPEED,
		value,
		"upgrade increase",
	);
	useEmitter().emit(EmitterEvents.PhaserRecalculateExplorationSpeed);
};
